import { useState } from "react";
import { DatabaseBackup, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { PageHeader, Panel, Empty, useFetch } from "@/components/common";
import { download } from "@/lib/api";

export default function Backup() {
  const [busy, setBusy] = useState(false);
  const hist = useFetch("/backup/history");
  const run = async () => {
    setBusy(true);
    try {
      const d = new Date(), p = (n) => String(n).padStart(2, "0");
      await download("/backup/export", {}, `sauvegarde-presthyg-${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}-${p(d.getHours())}h${p(d.getMinutes())}.zip`);
      toast.success("Sauvegarde téléchargée");
      hist.reload();
    } catch {
      toast.error("La sauvegarde a échoué, réessayez");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="max-w-3xl" data-testid="backup-page">
      <PageHeader overline="Paramètres" title="Sauvegarde complète" />
      <Panel testid="backup-panel">
        <p className="text-sm text-slate-600 leading-6">
          Téléchargez en une seule archive ZIP l'ensemble des données de l'application (véhicules, utilisateurs, contrôles, relevés, Mooncard,
          accidents, états des lieux, entretiens, matériel entrepôt, historiques) ainsi que toutes les photos et tous les documents.
          Les données sont au format JSON, lisibles sans l'application ; un fichier LISEZ-MOI explique le contenu.
        </p>
        <ul className="text-sm text-slate-600 mt-3 space-y-1 list-disc pl-5">
          <li>Les mots de passe ne sont jamais exportés.</li>
          <li>Recommandé : une sauvegarde par mois, conservée sur un support sécurisé (serveur ou disque de l'entreprise).</li>
        </ul>
        <div className="flex items-center gap-2 text-xs text-slate-500 mt-4"><ShieldCheck className="w-4 h-4 text-emerald-600" /> L'archive contient des données personnelles (permis, assurances) : ne la partagez pas.</div>
        <button onClick={run} disabled={busy} className="mt-5 h-12 px-6 rounded-lg bg-[#F49619] text-[#0E2D43] font-bold inline-flex items-center gap-2 disabled:opacity-60" data-testid="backup-download-button">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <DatabaseBackup className="w-5 h-5" />}
          {busy ? "Préparation de l'archive… (peut prendre quelques minutes)" : "Télécharger la sauvegarde complète"}
        </button>
      </Panel>
      <Panel title="Historique des sauvegardes" className="mt-6" flush testid="backup-history">
        {!hist.data?.length ? <Empty text="Aucune sauvegarde téléchargée pour le moment" /> : (
          <div className="overflow-x-auto"><table className="tbl w-full">
            <thead><tr><th>Date</th><th>Auteur</th><th>Enregistrements</th><th>Fichiers</th></tr></thead>
            <tbody>{hist.data.map((b, i) => (
              <tr key={b.at} data-testid={`backup-history-row-${i}`}>
                <td>{new Date(b.at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}</td>
                <td>{b.by}</td>
                <td>{Object.values(b.collections || {}).reduce((s, n) => s + n, 0).toLocaleString("fr-FR")}</td>
                <td>{b.files}</td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </Panel>
    </div>
  );
}
